import { FC } from 'react';
import { Heading } from '../../../../shared/Heading';
import styles from './SummaryPreview.module.scss';
import { Decorator } from 'components/shared/Decorator';
import { ExaminationResult, Content, Text } from 'api/maintestApi';
import { Texts } from 'components/shared/Texts';

interface SummaryPreviewProps {
  header: string;
  resultData?: ExaminationResult;
}

export const SummaryPreview: FC<SummaryPreviewProps> = ({
  header,
  resultData,
}) => {
  return (
    <div className={styles.summary_preview}>
      <Heading type="h2">{header}</Heading>
      <Decorator className={styles.decorator} />

      {resultData && (
        <ul className={styles.column}>
          {Object.entries(resultData).map(([sectionKey, sectionValue]) => {
            if (sectionKey === 'summary') {
              return null;
            }
            const contentData = sectionValue as Content;

            return (
              <li key={`SectionContent_${sectionKey}`}>
                {contentData.content.map((item: Text, index: number) =>
                  item.url !== undefined ? (
                    <a key={index} href={item.url} target="_blank">
                      {item.text}
                    </a>
                  ) : (
                    <Texts key={index} className={styles.paragraf}>
                      {item.text}
                    </Texts>
                  )
                )}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};
